<template>
	<div class="gachi" id="gachi" :class="{ 'gachi-main-background': isMain }">
		<nprogress-container />
		<skip-nav />

		<!-- s: header -->
		<main-header :open-aside-menu="menuActive" />
		<mobile-aside :is-non-active-menu="menuActive" :open-menu="isMenu" />
		<!-- e: header -->

		<!-- s: page-container -->
		<router-view />
		<!-- e: page-container -->

		<!-- s: footer -->
		<main-footer />
		<!-- e: footer -->

		<common-alert />
		<address-modal />
		<notification-modal v-if="commonNotice.show" />
		<loading-modal v-if="isLoading" />
	</div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
import SkipNav from './navigation/SkipNav';
import MainHeader from './header/MainHeader';
import MainFooter from './footer/MainFooter';
import { mapGetters } from 'vuex';
import { ACT_GET_SESSION, ACT_REMOVE_AUTH_TOKEN, ACT_GET_NOTICE } from '../../store/_act_consts';
import { MUT_SET_SESSION, MUT_SHOW_COMMON_NOTICE_MODAL } from '../../store/_mut_consts';
import { getItem, lengthCheck, dateToDateFormat, getItems } from '../../assets/js/utils';
import { countDDay } from '@/assets/js/DateUtils';
import CommonAlert from '../../components/common/CommonAlert';
import MobileAside from './navigation/MobileAside';
import AddressModal from '../../components/AddressModal';
import NotificationModal from '../../components/notification/NotificationModal';
import LoadingModal from '../../components/common/LoadingModal';

export default {
	name: 'MainLayout',
	components: {
		NprogressContainer,
		SkipNav,
		MobileAside,
		MainHeader,
		MainFooter,
		CommonAlert,
		AddressModal,
		NotificationModal,
		LoadingModal,
	},
	computed: {
		...mapGetters('auth', ['isAuth', 'session', 'profile']),
		...mapGetters('common', ['isMobile', 'address', 'isLoading', 'campn']),
		...mapGetters('notice', ['commonNotice']),
		...mapGetters('video', ['video']),
		isMain() {
			return this.grayNames.includes(this.$route.name);
		},
		campnEnd() {
			const nowDt = dateToDateFormat(new Date(), 'yyyy-MM-dd') + ' 00:00';
			if(countDDay(nowDt, this.campn.endDt) < 0){
				return true;
			} else {
				return false;
			}			
		},
	},
	// watch:{		// 축제기간 종료시 비행사 기간 메인 자동전환 주석처리 2024-10-02
	// 	$route(to) {
	// 		// console.log(to.path);
	// 		// console.log(to.params.path);
	// 		if (this.$route.name === 'Main' || this.$route.name === 'SubMain' || this.$route.path === '/') {
	// 			if(this.campnEnd){
	// 				this.$router.push({name: 'MainEnd'});
	// 			}
	// 		}
	// 	},
	// },
	data: () => ({
		isMenu: false,
		grayNames: ['Main'],
		msgCount: 0,
		items: [],
		currentYmd: '0',
		noticeItems: [],
		eduItems: [],
		supportItems: [],
	}),

	async created() {
		this.currentYmd = dateToDateFormat(new Date(), 'yyyyMMdd');

		if (this.isAuth && !this.session.userPattnCd) {
			try {
				const res = await this.$store.dispatch(`auth/${ACT_GET_SESSION}`);
				if (lengthCheck(res)) {
					await this.$store.commit(`auth/${MUT_SET_SESSION}`, getItem(res));
					// 여기서 ==> 알람을 처리한다
					// this.setMessageReceiveCountInterval();

					// if (this.$route.name === 'Main') {
					// 	this.getSurveyList(true);
					// }
				} else {
					await this.$store.dispatch(`auth/${ACT_REMOVE_AUTH_TOKEN}`);
				}
			} catch (e) {
				// console.error(e);
				await this.$store.dispatch(`auth/${ACT_REMOVE_AUTH_TOKEN}`);
			}
		}

		// console.log('route path : ', this.$route.path);
		// console.log('route name : ', this.$route.name);
		if (this.$route.name === 'Main' || this.$route.name === 'SubMain' || this.$route.path === '/') {
			// 축제기간 종료시 비행사 기간 메인 자동전환 주석처리 2024-10-02
			// if(this.campnEnd){
			// 	this.$router.push({name: 'MainEnd'});
			// }

			if (!this.$cookies.get('dh-notice-popup')) {
				this.getCommonNotice();
			}
		}
	},
	beforeDestroy() {},
	methods: {
		menuActive(menu) {
			this.isMenu = menu;
		},
		getCommonNotice() {
			this.$store
				.dispatch(`notice/${ACT_GET_NOTICE}`)
				.then((res) => {
					if (lengthCheck(res)) {
						this.noticeItems.push(...getItems(res));
						//this.showNoticeModal();
					}
					this.showNoticeModal(this.noticeItems);
				})
				.catch((e) => {
					console.error(e);
				});
		},
		showNoticeModal(item) {
			if (!this.checkDate('notice', item)) {
				return;
			}
			this.$store.commit(`notice/${MUT_SHOW_COMMON_NOTICE_MODAL}`, {});
		},
		checkDate(type, item) {
			if (type === 'survey') {
				return item.surveyBgngYmd <= this.currentYmd && item.surveyEndYmd >= this.currentYmd;
			} else if (type === 'notice' && item.length > 0) {
				return item[0].pstgBgngYmd <= this.currentYmd && item[0].pstgEndYmd >= this.currentYmd;
			}
		},
		goMainEnd(){
			if(this.campnEnd){
				this.$router.push({name: 'MainEnd'});
			}
		},
	},
};
</script>
